import styled from '@emotion/styled'
import { CvsButton } from '@components'
import { isOauthType, isOauthWithFieldsType } from './account-auth-type'

const FieldContainer = styled.div`
  margin-top: 15px;
`

interface SaveAccountProps {
  submitDisabled: boolean
  isSaving: boolean
  onSave: () => void
  connectorSlug: string
  isEdit: boolean
}

export const SaveAccount = ({
  submitDisabled,
  isSaving,
  onSave,
  connectorSlug,
  isEdit,
}: SaveAccountProps) => {
  function getSaveText(): string {
    if (isOauthType(connectorSlug)) {
      if (isEdit) {
        return isSaving ? 'Reconnecting' : 'Reconnect Account'
      }
      return isSaving ? 'Connecting' : 'Connect Account'
    }
    if (isOauthWithFieldsType(connectorSlug)) {
      return isSaving ? 'Saving' : 'Save and Connect Account'
    }
    return isSaving ? 'Saving' : 'Save Account'
  }

  return (
    <FieldContainer>
      <CvsButton
        fullWidth
        disabled={submitDisabled}
        onClick={onSave}
        variant="contained"
        color="primary"
      >
        {getSaveText()}
      </CvsButton>
    </FieldContainer>
  )
}
